import React  from "react";


const Careers = () => {

    return(
        <div className="about-container">
        <div className="content">
             <h1>Careers</h1>
           <i>Welcome to Brahma Jyoti Holdings Limited (BJHL).
We're always on the lookout for talented individuals who share our passion in corporate fields like BJHL.We're always excited to meet people who can contribute to our growing team.

Even though, there aren't currently any open positions, we encourage you to submit your resume or portfolio.</i>
        </div>
        </div>
    )
}


export default Careers;